export const capitaliz = (str) => {
    return (str || "").charAt(0).toUpperCase() + (str || "").slice(1).toLowerCase();
  };
  